import { useCallback, useMemo, useState } from 'react';
import { getLocalStorageValue, setLocalStorageValue } from 'src/utils/common';
import { LocalStorageKey } from 'src/utils/constants/ui-constants';

import { useApp } from 'src/stores/app-context';

/**
 * Firestore `config/commerce` 문서의 `globalNotice`(전역 공지)를 소비하는 훅.
 *
 * - 상시 운영 배너인 `notice`와는 별개 필드/표시 위치/수명주기다.
 * - "다시 보지 않기"는 `globalNotice.id` 기준으로 localStorage에 저장한다.
 *   운영이 `id`를 바꾸면 이전에 닫은 사용자에게도 자동 재노출된다.
 * - `dismissible === false`면 사용자가 닫을 수 없다(닫기 버튼 숨김).
 * - `globalNotice`가 없거나 `null`이면 미노출.
 */
const useGlobalNotice = () => {
  const { commerceConf } = useApp();
  const globalNotice = commerceConf.globalNotice ?? null;

  const [dismissedId, setDismissedId] = useState<string | undefined>(() =>
    getLocalStorageValue<string>(LocalStorageKey.dismissedGlobalNoticeId)
  );

  const dismiss = useCallback(() => {
    if (!globalNotice) {
      return;
    }
    setLocalStorageValue(LocalStorageKey.dismissedGlobalNoticeId, globalNotice.id);
    setDismissedId(globalNotice.id);
  }, [globalNotice]);

  const visible = useMemo(() => globalNotice !== null && globalNotice.id !== dismissedId, [globalNotice, dismissedId]);

  return { globalNotice, visible, dismiss };
};

export default useGlobalNotice;
